//# sourceMappingURL=automations.mjs.map
/// <reference types="./automations.d.mts" />
import * as $ask from "../../../altar/altar/ask.mjs";
import * as $endpoints from "../../../altar/altar/endpoints.mjs";
import * as $admin_automations from "../../../data_types/data/admin_automations.mjs";
import * as $ai_metrics from "../../../data_types/data/ai_metrics.mjs";
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $fetch from "../../../gleam_fetch/gleam/fetch.mjs";
import * as $form_data from "../../../gleam_fetch/gleam/fetch/form_data.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $request from "../../../gleam_http/gleam/http/request.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $bit_array from "../../../gleam_stdlib/gleam/bit_array.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $set from "../../../gleam_stdlib/gleam/set.mjs";
import * as $file from "../../../magellan/magellan/file.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $toast from "../../../redraw_toastify/toastify/toast.mjs";
import * as $super_admin from "../../admin/effects/super_admin.mjs";
import { apply_org_header } from "../../admin/effects/super_admin.mjs";
import * as $middleware from "../../admin/middleware.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { Ok, toList, makeError } from "../../gleam.mjs";

const FILEPATH = "src/admin/effects/automations.gleam";

export function compute_proposal_metrics(org_id, selected_metrics, proposal_id) {
  return $effect.from(
    (_, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          return $middleware.require_user_id(
            store,
            (user_id) => {
              let _pipe = $ask.to(
                new $ask.Heimdall(),
                toList(["admin", "proposal-metrics"]),
              );
              let _pipe$1 = $ask.via(_pipe, new $http.Post());
              let _pipe$2 = $ask.bearing(_pipe$1, access_token);
              let _pipe$3 = $ask.with$(
                _pipe$2,
                $json.object(
                  toList([
                    ["org_id", $json.string(org_id)],
                    ["user_id", $json.string(user_id)],
                    ["proposal_id", $json.string(proposal_id)],
                    [
                      "metrics",
                      (() => {
                        let _pipe$3 = selected_metrics;
                        let _pipe$4 = $set.to_list(_pipe$3);
                        return $json.array(_pipe$4, $ai_metrics.encode);
                      })(),
                    ],
                  ]),
                ),
              );
              return $ask.run(_pipe$3);
            },
          );
        },
      );
    },
  );
}

export function rerun_proposal(org_id, proposal_id, config) {
  return $effect.from(
    (_, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          return $middleware.require_user_id(
            store,
            (user_id) => {
              let _pipe = $ask.to(
                new $ask.Heimdall(),
                toList(["admin", "rerun-proposal"]),
              );
              let _pipe$1 = $ask.via(_pipe, new $http.Post());
              let _pipe$2 = $ask.bearing(_pipe$1, access_token);
              let _pipe$3 = $ask.with$(
                _pipe$2,
                $json.object(
                  toList([
                    ["org_id", $json.string(org_id)],
                    ["user_id", $json.string(user_id)],
                    ["proposal_id", $json.string(proposal_id)],
                    ["config", $json.string(config)],
                  ]),
                ),
              );
              return $ask.run(_pipe$3);
            },
          );
        },
      );
    },
  );
}

/**
 * Manually run the Slack digest job on heimdall, for the organization
 * currently selected in the admin panel (sent through the super-admin org
 * header). The job still honours each user's digest day/hour preferences.
 */
export function trigger_digest() {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(new $ask.Admin(), toList(["trigger-digest"]));
          let _pipe$1 = $ask.via(_pipe, new $http.Post());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = apply_org_header(_pipe$2, store);
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (_) => {
              let _pipe$4 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Success(),
                "Digest trigger completed",
              );
              return dispatch(_pipe$4);
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (_) => {
              let _pipe$5 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Error(),
                "Digest trigger failed",
              );
              return dispatch(_pipe$5);
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

/**
 * Manually run the Auth0 organizations sync job on heimdall, as the 12h
 * cron does. This is a global action, not scoped to a single organization.
 */
export function trigger_auth0_organizations_sync() {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Admin(),
            toList(["trigger-auth0-organizations-sync"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Post());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.on_success(
            _pipe$2,
            (_) => {
              let _pipe$3 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Success(),
                "Auth0 organizations sync completed",
              );
              return dispatch(_pipe$3);
            },
          );
          let _pipe$4 = $ask.on_error(
            _pipe$3,
            (_) => {
              let _pipe$4 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Error(),
                "Auth0 organizations sync failed",
              );
              return dispatch(_pipe$4);
            },
          );
          return $ask.run(_pipe$4);
        },
      );
    },
  );
}

/**
 * Manually run one batch of the worksheets-to-S3 backfill on heimdall. The
 * cron is gone since both backlogs are drained; this is the on-demand
 * replacement.
 */
export function trigger_worksheets_backfill() {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Admin(),
            toList(["trigger-worksheets-backfill"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Post());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.on_success(
            _pipe$2,
            (_) => {
              let _pipe$3 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Success(),
                "Worksheets backfill batch completed",
              );
              return dispatch(_pipe$3);
            },
          );
          let _pipe$4 = $ask.on_error(
            _pipe$3,
            (_) => {
              let _pipe$4 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Error(),
                "Worksheets backfill failed",
              );
              return dispatch(_pipe$4);
            },
          );
          return $ask.run(_pipe$4);
        },
      );
    },
  );
}

export function rerun_insights(org_id) {
  return $effect.from(
    (_, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(new $ask.Heimdall(), toList(["rerun-insights"]));
          let _pipe$1 = $ask.via(_pipe, new $http.Post());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.with$(
            _pipe$2,
            $json.object(toList([["org_id", $json.string(org_id)]])),
          );
          return $ask.run(_pipe$3);
        },
      );
    },
  );
}

export function reingest_data(org_id) {
  return $effect.from(
    (_, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["content-library", "re-ingest", "v1"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Post());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.with$(
            _pipe$2,
            $json.object(toList([["org_id", $json.string(org_id)]])),
          );
          return $ask.run(_pipe$3);
        },
      );
    },
  );
}

export function sync_pg_and_weaviate(org_id, reingest, dry_run) {
  return $effect.from(
    (_, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["sync-pg-and-weaviate"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Post());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.with$(
            _pipe$2,
            $json.object(
              toList([
                ["org_id", $json.string(org_id)],
                ["dry_run", $json.bool(dry_run)],
                ["re_ingest", $json.bool(reingest)],
              ]),
            ),
          );
          return $ask.run(_pipe$3);
        },
      );
    },
  );
}

export function download_exported_content(content) {
  return $effect.from(
    (_, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (_) => {
          return $middleware.require_org_id(
            store,
            (org_id) => {
              let name = ("question_bank-" + org_id) + ".csv";
              return $file.download(name, $bit_array.from_string(content));
            },
          );
        },
      );
    },
  );
}

export function export_content_library(export_type, org_id) {
  return $effect.from_(
    (_, get_state, dispatch_effect) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["export-content-library"]),
          );
          let _pipe$1 = $ask.via(_pipe, new $http.Post());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.with$(
            _pipe$2,
            $json.object(
              toList([
                ["org_id", $json.string(org_id)],
                [
                  "export_type",
                  $json.string($admin_automations.to_string(export_type)),
                ],
              ]),
            ),
          );
          let _pipe$4 = $ask.expect(
            _pipe$3,
            $decode.at(toList(["content"]), $decode.string),
          );
          let _pipe$5 = $ask.on_success(
            _pipe$4,
            (c) => {
              dispatch_effect(download_exported_content(c));
              return undefined;
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

/**
 * Performing parsing on backend instead of frontend
 * Some sitemaps containg 4k+ links so let's avoid performance issues
 */
export function parse_sitemap(url) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(new $ask.Admin(), toList(["sitemap", "parse"]));
          let _pipe$1 = $ask.via(_pipe, new $http.Post());
          let _pipe$2 = $ask.bearing(_pipe$1, access_token);
          let _pipe$3 = $ask.with$(
            _pipe$2,
            $json.object(toList([["url", $json.string(url)]])),
          );
          let _pipe$4 = $ask.expect(
            _pipe$3,
            $decode.at(toList(["urls"]), $decode.list($decode.string)),
          );
          let _pipe$5 = $ask.on_success(
            _pipe$4,
            (urls) => {
              let _pipe$5 = new $msg.Sitemap(
                new $msg.ApiReturnedSitemapUrls(new $remote.Loaded(urls)),
              );
              return dispatch(_pipe$5);
            },
          );
          let _pipe$6 = $ask.on_error(
            _pipe$5,
            (_) => {
              let _pipe$6 = new $msg.Sitemap(
                new $msg.ApiReturnedSitemapUrls(
                  new $remote.Errored("Could not fetch or parse this sitemap."),
                ),
              );
              return dispatch(_pipe$6);
            },
          );
          return $ask.run(_pipe$6);
        },
      );
    },
  );
}

export function generate_sitemap_zip(urls, batch_size) {
  return $effect.from(
    (_, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let url = $endpoints.heimdall() + "/admin/sitemap/zip";
          let $ = $request.to(url);
          let request;
          if ($ instanceof Ok) {
            request = $[0];
          } else {
            throw makeError(
              "let_assert",
              FILEPATH,
              "admin/effects/automations",
              266,
              "generate_sitemap_zip",
              "Pattern match failed, no pattern matched the value.",
              {
                value: $,
                start: 8049,
                end: 8089,
                pattern_start: 8060,
                pattern_end: 8071
              }
            )
          }
          let _block;
          let _pipe = $json.object(
            toList([
              ["urls", $json.array(urls, $json.string)],
              ["batch_size", $json.int(batch_size)],
            ]),
          );
          _block = $json.to_string(_pipe);
          let body = _block;
          let _pipe$1 = request;
          let _pipe$2 = $request.set_method(_pipe$1, new $http.Post());
          let _pipe$3 = $request.set_header(
            _pipe$2,
            "authorization",
            "Bearer " + access_token,
          );
          let _pipe$4 = $request.set_header(
            _pipe$3,
            "content-type",
            "application/json",
          );
          let _pipe$5 = $request.set_body(_pipe$4, body);
          let _pipe$6 = $fetch.send(_pipe$5);
          let _pipe$7 = $promise.try_await(_pipe$6, $fetch.read_bytes_body);
          return $promise.await$(
            _pipe$7,
            (result) => {
              if (result instanceof Ok) {
                let resp = result[0];
                if ((resp.status >= 200) && (resp.status < 300)) {
                  return $file.download("sitemap_batches.zip", resp.body);
                } else {
                  return $promise.resolve(undefined);
                }
              } else {
                return $promise.resolve(undefined);
              }
            },
          );
        },
      );
    },
  );
}

export function unlock_sheet(f) {
  return $effect.from(
    (_, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let file_name = $file.name(f);
          return $promise.await$(
            $file.bytes(f),
            (blob) => {
              let url = $endpoints.nabu() + "/admin/unlock-sheet";
              let $ = $request.to(url);
              let request;
              if ($ instanceof Ok) {
                request = $[0];
              } else {
                throw makeError(
                  "let_assert",
                  FILEPATH,
                  "admin/effects/automations",
                  297,
                  "unlock_sheet",
                  "Pattern match failed, no pattern matched the value.",
                  {
                    value: $,
                    start: 9053,
                    end: 9093,
                    pattern_start: 9064,
                    pattern_end: 9075
                  }
                )
              }
              let _block;
              let _pipe = $form_data.new$();
              let _pipe$1 = $form_data.append_bits(_pipe, "blob", blob);
              _block = $form_data.append(_pipe$1, "name", file_name);
              let fd = _block;
              let _pipe$2 = request;
              let _pipe$3 = $request.set_method(_pipe$2, new $http.Post());
              let _pipe$4 = $request.set_header(
                _pipe$3,
                "authorization",
                "Bearer " + access_token,
              );
              let _pipe$5 = $request.set_body(_pipe$4, fd);
              let _pipe$6 = $fetch.send_form_data(_pipe$5);
              let _pipe$7 = $promise.try_await(_pipe$6, $fetch.read_bytes_body);
              return $promise.await$(
                _pipe$7,
                (result) => {
                  if (result instanceof Ok) {
                    let resp = result[0];
                    if ((resp.status >= 200) && (resp.status < 300)) {
                      return $file.download(file_name, resp.body);
                    } else {
                      return $promise.resolve(undefined);
                    }
                  } else {
                    return $promise.resolve(undefined);
                  }
                },
              );
            },
          );
        },
      );
    },
  );
}
